export default __webpack_public_path__ + "static/card-setup-pix-mobile-1d354f84db4bbf26ce34e0fb49558e9f.png";